import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import validationSchema from 'src/utils/validationSchema';

import { useTranslate } from 'src/locales';
import { useChannelContext } from 'src/pages/channel/hooks';

export function useSmsStep3() {
  const { t } = useTranslate('translation');
  const { state: channelState, isLoading, handleSmsDetails, onChangeStep } = useChannelContext();

  const schema = validationSchema(
    [
      { name: 'channelName', required: true },
      { name: 'accountSid', required: true },
      { name: 'authToken', required: true },
      { name: 'srcNumber', required: true },
    ],
    t
  );

  type FormValues = {
    channelName: string;
    accountSid: string;
    authToken: string;
    srcNumber: string;
  };

  const methods = useForm<FormValues>({
    mode: 'all',
    resolver: zodResolver(schema),
    values: {
      channelName: channelState.channelName || '',
      accountSid: channelState.smsChannelDtls?.accountSid || '',
      authToken: channelState.smsChannelDtls?.authToken || '',
      srcNumber: channelState.smsChannelDtls?.srcNumber || '',
    },
  });

  const { handleSubmit, watch } = methods;

  const formValues = {
    channelName: watch('channelName'),
    accountSid: watch('accountSid'),
    authToken: watch('authToken'),
    srcNumber: watch('srcNumber'),
  };

  const onSubmit = handleSubmit((data) => {
    handleSmsDetails(data);
    onChangeStep('next');
  });

  const isNextDisabled = Object.values(formValues).some((value) => !value);

  return {
    methods,
    formValues,
    isLoading,
    isNextDisabled,
    providerType: channelState?.SMSProviderType,
    onSubmit,
  };
}
